// src/pages/Home/HomePage.jsx (ou équivalent)
import React, { useEffect } from "react";
import Header from "./Header";
import About from "./About";
import Diaporama from "./Diaporama";
import ContactForm from "./ContactForm";
import useScrollToTop from "../../hooks/useScrollToTop";
import ScrollIndicator from "./../../hooks/ScrollIndicator";
import { useUser } from "./../../contexts/UserContext";
import AuthIcons from "./../../hooks/AuthIcons";
import NosEquipes from "./NosEquipes";
import PartenairesCarousel from "./PartenairesCarousel";
import LastGallerie from "./LastGallerie";
import LastNews from "./LastNews";
import UpcomingEvents from "./UpcomingEvents";
import LastAnnoncesClub from "./LastAnnoncesClub";
import LastArticlesCommissions from "./LastArticlesCommissions";
import LastVieClubs from "./LastVieClubs";
import { saveVisite } from "../../services/visitesServices";
import "./Home.css";

const HomePage = () => {
  useScrollToTop();
  const { user } = useUser();

  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    const lastVisitDate = localStorage.getItem("lastVisitDate");

    if (lastVisitDate !== today) {
      saveVisite();
      localStorage.setItem("lastVisitDate", today);
    }
  }, []);

  return (
    <div className="bg-slate-50 dark:bg-slate-900 text-slate-900 dark:text-slate-100 min-h-screen">
      {/* Icônes de connexion flottantes (si tu en as besoin) */}
      {!user && <AuthIcons />}

      <ScrollIndicator />

      {/* Padding pour compenser la navbar fixe (80/96px) */}
      <main className="pt-[80px] md:pt-[96px] space-y-10 md:space-y-16">
        <section id="home">
          <Header />
        </section>

        <section id="about">
          <About />
        </section>

        <section>
          <Diaporama />
        </section>

        <section id="equipes">
          <NosEquipes />
        </section>

        <section id="events">
          <UpcomingEvents />
        </section>

        <section id="news">
          <LastNews />
        </section>

        <section id="galerie">
          <LastGallerie />
        </section>

        <section id="articles">
          <LastArticlesCommissions />
        </section>

        <section id="annonces">
          <LastAnnoncesClub />
        </section>

        <section id="vieclubs">
          <LastVieClubs />
        </section>

        <section id="partenaires">
          <PartenairesCarousel />
        </section>

        <section id="contact">
          <ContactForm />
        </section>
      </main>
    </div>
  );
};

export default HomePage;
